import { useEffect, useState } from 'react';
import { useSubscription, useApolloClient } from '@apollo/client';
import { RodRequest, RodRequestsSubscriptionPayload } from '@bechtel/types';
import { SUBSCRIPTION_ROD_REQUEST_UPDATED, SUBSCRIPTION_ROD_REQUEST_CREATED } from '@bechtel/client-gql';
import { useRodRequestCache } from '~/hooks/use-rod-request-cache';

export function useRodRequestSubscription() {
  const response = useState<RodRequest['id']>('');
  const { data: updatedRodRequestData } = useSubscription<{ rodRequestsUpdated: RodRequestsSubscriptionPayload }>(
    SUBSCRIPTION_ROD_REQUEST_UPDATED
  );
  const { data: createdRodRequestData } = useSubscription<{ rodRequestsCreated: RodRequestsSubscriptionPayload }>(
    SUBSCRIPTION_ROD_REQUEST_CREATED
  );
  const { updateRodRequestCache } = useRodRequestCache();
  const setRodRequestId = response[1];
  const client = useApolloClient();

  //ToDo: Need to implement rodRoomId in updateRodRequest subscription. Discussion is pending with BE.

  const updateRodRoomStats = async () => {
    await client.refetchQueries({
      include: ['rodRoomStatsSummary'],
    });
  };

  useEffect(() => {
    if (
      !updatedRodRequestData ||
      !updatedRodRequestData.rodRequestsUpdated ||
      !updatedRodRequestData.rodRequestsUpdated.rodRequestIds ||
      updatedRodRequestData.rodRequestsUpdated.rodRequestIds.length === 0
    )
      return;
    setRodRequestId('');
    updateRodRequestCache(updatedRodRequestData.rodRequestsUpdated.rodRequestIds);
    updateRodRoomStats();
  }, [updatedRodRequestData]);

  useEffect(() => {
    if (
      !createdRodRequestData ||
      !createdRodRequestData.rodRequestsCreated ||
      !createdRodRequestData.rodRequestsCreated.rodRequestIds ||
      createdRodRequestData.rodRequestsCreated.rodRequestIds.length === 0
    )
      return;
    setRodRequestId(createdRodRequestData.rodRequestsCreated.rodRequestIds[0]);
    updateRodRoomStats();
  }, [createdRodRequestData]);

  return response;
}
